import React, { useRef } from "react";
import { Box, Grid, Typography } from "@mui/material";

import Banner from "../../../../Common/Components/Banner";
import CarModel from "../../../../Common/Components/CarModel";
import DetailedInfo from "../../../../Common/Components/DetailedInfo";
import ShowInterest from "../../../../Common/Container/showintrestCon";
import Wsp from "../../../contact/Component/Floatingwsp";

import SyrosEvNavbar from "../../SyrosEV/Component/SyrosEvNavbar";
import AccordionShowcase from "../../SyrosEV/Component/AccordionShowcase";
import PeekCarousel from "../../SyrosEV/Component/PeekCarousel";
import VariantPricing from "../../SyrosEV/Component/VariantPricing";
import VideoSection from "../../NEWSELTOS/VideoSection";

import ExploreVideo from "./ExploreVideo";
import EvolutionTimeline from "./EvolutionTimeline";
import { LovedByWorld, Awards } from "./GlobalRecognition";

import {
  BannerData,
  BrochureLink,
  LifestyleImage,
  HighlightsData,
  CircleData,
  ExploreVideoData,
  ExteriorShowcase,
  InteriorShowcase,
  SafetyShowcase,
  ComfortShowcase,
  ConnectivityShowcase,
  AdasShowcase,
  VariantData,
  ProductFilm,
  EvolutionData,
  LovedByWorldData,
  AwardsData,
  DetailInfo,
} from "./Data";

const menuItems = [
  { name: "Exterior", section: "exterior" },
  { name: "Interior", section: "interior" },
  { name: "Safety", section: "safety" },
  { name: "Comfort", section: "comfort" },
  { name: "Connectivity", section: "connectivity" },
  { name: "ADAS", section: "adas" },
];

export default function Sorento() {
  const showInterestRef = useRef(null);
  const exteriorRef = useRef(null);
  const interiorRef = useRef(null);
  const safetyRef = useRef(null);
  const comfortRef = useRef(null);
  const connectivityRef = useRef(null);
  const adasRef = useRef(null);

  const refs = {
    exterior: exteriorRef,
    interior: interiorRef,
    safety: safetyRef,
    comfort: comfortRef,
    connectivity: connectivityRef,
    adas: adasRef,
    showInterest: showInterestRef,
  };

  const scrollToSection = (section) => {
    const ref = refs[section];
    if (ref?.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleBookNow = () => {
    window.open("tel:+911800108500", "_self");
  };

  return (
    <Box sx={{ overflowX: "hidden" }}>
      <Banner bannerData={BannerData} />
      <SyrosEvNavbar
        title="The Kia Sorento"
        menuItems={menuItems}
        scrollToSection={scrollToSection}
        brochureLink={BrochureLink}
        onBookNow={handleBookNow}
      />

      <Grid container justifyContent="center">
        <Grid item xs={12} sm={11} py={1}>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{
              fontFamily: "KIAbodyLatinbasic_Regular",
              textAlign: "center",
              display: "block",
            }}
          >
            Disclaimer: The product shown in the visual is for representation purposes only.
            Colors, features, and actual product may vary. Please check with your local Kia
            dealer for more details. #T&amp;C apply.
          </Typography>
        </Grid>
      </Grid>

      <Box
        component="picture"
        sx={{ display: "block", width: "100%", height: { xs: "70vh", md: "100vh" } }}
      >
        <source srcSet={LifestyleImage.mobileImageUrl} media="(max-width: 720px)" />
        <Box
          component="img"
          src={LifestyleImage.imageUrl}
          alt={LifestyleImage.alt}
          loading="lazy"
          decoding="async"
          sx={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
        />
      </Box>

      <AccordionShowcase {...HighlightsData} />

      <CarModel model="Sorento" CircleData={CircleData} bgCar={ExploreVideoData.videoUrl} />

      <div ref={showInterestRef} className="section-anchor">
        <ShowInterest someValue="Sorento" />
      </div>

      <ExploreVideo {...ExploreVideoData} />

      <div ref={exteriorRef} className="section-anchor">
        <PeekCarousel {...ExteriorShowcase} />
      </div>

      <div ref={interiorRef} className="section-anchor">
        <PeekCarousel {...InteriorShowcase} />
      </div>

      <div ref={safetyRef} className="section-anchor">
        <PeekCarousel {...SafetyShowcase} />
      </div>

      <div ref={comfortRef} className="section-anchor">
        <PeekCarousel {...ComfortShowcase} />
      </div>

      <div ref={connectivityRef} className="section-anchor">
        <PeekCarousel {...ConnectivityShowcase} />
      </div>

      <div ref={adasRef} className="section-anchor">
        <PeekCarousel {...AdasShowcase} />
      </div>

      <VariantPricing
        title="Meet the Family"
        variants={VariantData}
        onConfigure={() => scrollToSection("showInterest")}
      />

      <VideoSection {...ProductFilm} />

      <EvolutionTimeline {...EvolutionData} />

      <LovedByWorld {...LovedByWorldData} />

      <Awards {...AwardsData} />

      <DetailedInfo
        DetailInfo={DetailInfo}
        onScrollToInterest={() => scrollToSection("showInterest")}
      />

      <Wsp />
    </Box>
  );
}
